import { faCalendarWeek } from '@fortawesome/pro-duotone-svg-icons/faCalendarWeek';
import { faClock } from '@fortawesome/pro-duotone-svg-icons/faClock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { colors } from 'us-react-components/dist/constants/Styles';
import { DateFormat, formatDateFromString, formatDateToString } from 'us-react-components/dist/utils/date';
import { RecurringDay } from 'us-web-services';
import { useDependencies } from '../../../../dependencies';
import { IconText } from './IconText';

const SPECIFIC_TIME_CODE = 'specific';

const RecurringSummary = (): JSX.Element => {
  const { stores: { familyRegistration } } = useDependencies();
  const isSpecific = familyRegistration.recurring?.timeOfDay?.code === SPECIFIC_TIME_CODE;

  const getDayOfWeekString = (): string => {
    if (familyRegistration.recurring?.flexible) {
      return `${familyRegistration.daysOfTheWeekString} (flexible)`;
    }

    return familyRegistration.daysOfTheWeekString;
  };

  const getFormattedTime = (time?: string): string => {
    if (time) {
      const currentDate = formatDateToString(new Date(), DateFormat.API_DATE_FORMAT);
      const dateString = `${currentDate} ${time}`;

      return formatDateFromString(dateString, DateFormat.TIME_DISPLAY_FORMAT);
    }

    return '';
  };

  return (
    <>
      {
        familyRegistration.daysOfTheWeekString &&
        <IconText icon={faCalendarWeek} text={getDayOfWeekString()} />
      }
      <span className='text-sm pb-2 flex flex-row items-center'>
        <div className='min-w-[20px] self-start'>
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          <FontAwesomeIcon icon={faClock} size='xl' style={{ '--fa-primary-color': colors.emerald.DEFAULT, '--fa-secondary-color': colors.emerald[300] } as any} />
        </div>
        <div>
          {isSpecific && familyRegistration.recurring?.days?.map((input: RecurringDay) => (
            <div key={input.weekday.id} className='text-sm pl-2'>
              {`${input.weekday.code} ${getFormattedTime(input.startTime)} - ${getFormattedTime(input.endTime)}`}
            </div>
          ))}
          {!isSpecific && (
            <div className='text-sm pl-2'>
              {familyRegistration.recurring?.timeOfDay?.label}
            </div>
          )}
        </div>
      </span>
    </>
  );
};

export { RecurringSummary };
